// extracted by mini-css-extract-plugin
module.exports = {"message":"SignUp_message__O5svl","success":"SignUp_success___Sez3","failed":"SignUp_failed__2Bu4Y"};